await import(`@liferay/language/${Liferay.ThemeDisplay.getLanguageId()}/frontend-data-set-web/all.js`);
/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import {ICreationActionItem} from '../../management_bar/controls/CreationMenu';

const filterCreationActions = ({
	customActions,
	globalCollectionActions,
}: {
	customActions: Array<ICreationActionItem>;
	globalCollectionActions: any;
}): Array<ICreationActionItem> => {
	return customActions.filter((action: ICreationActionItem) => {
		if (
			!action.data?.permissionKey ||
			(action.data?.permissionKey &&
				Object.keys(globalCollectionActions).some((globalAction) => {
					if (action.data?.permissionKey) {
						return (
							globalAction.toLowerCase() ===
							action.data.permissionKey.toLowerCase()
						);
					}
				}))
		) {
			return action;
		}
	});
};

export default filterCreationActions;
